import { createTypes, createAction } from "lib/action";

const CREATE_FAQ = createTypes("faq", "create");
const SHOW_FAQ = createTypes("faq", "show");
const UPDATE_FAQ = createTypes("faq", "update");

const createFaq = {
  request: (params, token) =>
    createAction(CREATE_FAQ.REQUEST, { params, token }),
  success: (data) => createAction(CREATE_FAQ.SUCCESS, { data }),
  failure: (err) => createAction(CREATE_FAQ.FAILURE, { err }),
};

const showFaq = {
  request: (id, token) => createAction(SHOW_FAQ.REQUEST, { id, token }),
  success: (data) => createAction(SHOW_FAQ.SUCCESS, { data }),
  failure: (err) => createAction(SHOW_FAQ.FAILURE, { err }),
};

const updateFaq = {
  request: (params, id, token) =>
    createAction(UPDATE_FAQ.REQUEST, { params, id, token }),
  success: (data) => createAction(UPDATE_FAQ.SUCCESS, { data }),
  failure: (err) => createAction(UPDATE_FAQ.FAILURE, { err }),
};

export { createFaq, showFaq, updateFaq, CREATE_FAQ, SHOW_FAQ, UPDATE_FAQ };
